export const whiteColor = '#ffffff'
export const blackColor = '#000000'
export const primaryColor = '#19A5FF'
export const primaryColorLight1 = '#7085a5'
export const primaryColorLight2 = '#e9ebf1'
export const primaryColorLight3 = '#eceff3'
export const primaryColorLight4 = '#d8dbe2'
export const defaultColor = '#767776'
export const defaultColorMiddle = '#919191'
export const defaultColorMiddle1 = '#a8a8a8'
export const defaultColorBold = '#494949'
export const defaultColorBold1 = '#363636'
export const defaultColorBoldOpacity = 'rgba(71, 71, 71, 0.85)'
export const defaultColorLight1 = '#d8d8d8'
export const defaultColorLight2 = '#f0f0f0'
export const warningColor = '#ec9e4f'
export const warningColorLight1 = '#ffeba3'
export const warningColorLight2 = '#fffae8'
export const successColor = '#51DAC5'
export const successBright = '#88b550'
export const dangerColor = '#FF6845'
export const dangerColorLight = '#DC1A45'
export const infoColor = '#4ba7e6'
export const lightGray = '#9ca3af'



// WEBPACK FOOTER //
// ./src/constants/colors.js